
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import Checkbox from '@material-ui/core/Checkbox';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
import { Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
import TimelogFile from '../Resources/Example of Timelogs.csv';
import TimelogServices from '../Services/TimelogService/timelogService';
import Select from 'react-select';
var base64 = require('base-64');

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}
class TimelogImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            UploadInputKey: 'timelogInputUpload',
            TimelogList: { pennding: false, value: [] },
            TimelogUpList: { pennding: false, value: [] },
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            FileName: "Choose a file",
            selectedValue: '2',
            selectAllDuplicates: false,
            isAutenticated: true,
            Headers: false,
            TimeLogHeaders: null
        };
        this.onChange = this.onChange.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.SelectedAllDuplicates = this.SelectedAllDuplicates.bind(this);
    }

    SelectedAll(e) {
        if (e.target.checked) {
            let optionChecked = [];
            this.state.TimelogList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.ID);
            })
            this.setState({ checkboxOptions: optionChecked })
        }
        else {
            this.setState({ checkboxOptions: [] })
        }
    }
    handleData = (e) => {

        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();
        debugger
        this.setState({
            UploadInputKey: e.target.files[0]['lastModified'] + e.target.files[0]['size'] + e.target.files[0]['name'],
            TimelogList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });

        if (uploadedFile) {
            if (extFile.toUpperCase() !== "CSV") {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }

            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                var base64result = reader.result.split(',')[1];
                var encoded = base64.decode(base64result);
                var data = encoded.split('\n');
                var DataList = [];
                data.forEach(element => {
                    DataList.push(element.split(','));
                });


                let userId = "";               //USER_ID
                let timelog = "";              //LOG_TIME
                let deviceSerialNumber = "";   //DEVICE_SERIAL_NUMBER
                let jobCode = "";              //JOB_CODE
                let clocking = "";             //CLOCKING_TYPE0
                let stringClockType = "";      //STRING_CLOCKING_TYPE0

                DataList[0].forEach((elem) => {
                    let processedElement = elem.replace(/\s/g, "").toUpperCase();
                    switch (processedElement) {
                        case "USERID(REQUIRED)": {
                            userId = elem;
                            break;
                        }
                        case "LOGTIME(REQUIRED)": {
                            timelog = elem;
                            break;
                        }
                        case "DEVICESERIALNUMBER": {
                            deviceSerialNumber = elem;
                            break;
                        }
                        case "JOBCODE": {
                            jobCode = elem;
                            break;
                        }
                        case "CLOCKINGTYPE": {
                            clocking = elem;
                            break;
                        }
                        case "STRINGCLOCKINGTYPE": {
                            stringClockType = elem;
                            break;
                        }
                        default: {
                            break
                        }
                    }
                });

                this.setState({
                    TimelogUpList: { pennding: true, value: DataList },
                    HeadersList: DataList[0],
                    Headers: true,
                    FileName: name,
                    TimeLogHeaders: {
                        UserId: { value: userId, label: userId },
                        LogTime: { value: timelog, label: timelog },
                        DeviceSerialNumber: { value: deviceSerialNumber, label: deviceSerialNumber },
                        JobCode: { value: jobCode, label: jobCode },
                        ClockingType: { value: clocking, label: clocking },
                        StringClockingType: { value: stringClockType, label: stringClockType }
                    }
                })

            }
            reader.readAsDataURL(uploadedFile);
        }
        else {
            this.setState({
                TimelogList: { pennding: true, value: [] },
                HeadersList: [],
                Headers: true,
                FileName: "Choose File",
                TimeLogHeaders: null
            });
        }
    }

    handleChange = event => {
        this.setState({
            selectedValue: event.target.value
        });
        var ActionType = event.target.value;
        var DataList = this.state.TimelogUpList.value;
        var Duplicates = this.state.selectAllDuplicates ? "1" : "2";

        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });

        } else {
            if (this.props.CompanyCode && DataList) {
                this.setState({
                    TimelogList: { pennding: true, value: [] }
                });
                var ListResult = TimelogServices.getTimelogsListResult(this.props.CompanyCode, DataList, ActionType, Duplicates);
                var that = this;
                ListResult.then(function (data) {
                    if (data.status === 200) {
                        that.setState({
                            TimelogList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    }
                }).catch((error) => {
                    that.setState({
                        TimelogList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }

    getAllAgain() {
        var ActionType = this.state.selectedValue;
        var DataList = this.state.TimelogUpList.value;
        var Duplicates = this.state.selectAllDuplicates ? "1" : "2";
        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {
            if (this.props.CompanyCode && DataList) {
                this.setState({
                    TimelogList: { pennding: true, value: [] }
                });
                var ListResult = TimelogServices.getTimelogsListResult(this.props.CompanyCode, DataList, ActionType, Duplicates);
                var that = this;
                ListResult.then(function (data) {
                    if (data.status === 200) {
                        that.setState({
                            TimelogList: { pennding: false, value: data.data },
                            checkboxOptions: [],
                        });
                    }
                }).catch((error) => {
                    that.setState({
                        TimelogList: { pennding: false, value: [] },
                        checkboxOptions: [],
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }

    SelectedAllDuplicates(e) {
        //let options = e.target.checked; 
        this.setState({ selectAllDuplicates: e.target.checked }, () => { this.getAllAgain() })
    }

    onChange(e, code) {
        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options })
    }

    // changeName(e) {
    //     //alert(e.target.value)
    //     var str = e.target.value;
    //     var res = str.substring(12)
    //     var extention = res.split('.').pop();
    //     if (extention.toUpperCase() === "CSV") {
    //         this.setState({
    //             FileName: res
    //         });
    //     } else {
    //         this.setState({
    //             FileName: "CHOOSE A FILE",
    //             DepartmentUpList: { pennding: false, value: [] },
    //         });
    //         toast.error("File Error!", {
    //             className: {
    //                 opacity: 0.8
    //             }
    //         });
    //         return false;
    //     }
    //     return true;
    // }


    SaveTimelogList(e) {
        e.preventDefault();

        var CheckboxList = this.state.checkboxOptions;
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];
        var that = this;
        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a Time Log and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var department = this.state.TimelogList.value.find(x => x.ID === l);
                result.push(department);
            });
            var DataResult = TimelogServices.SaveTimelog(this.props.CompanyCode, result, ActionType, email);
            DataResult.then(function (data) {
                let toastMessage = null;
                if (data.data === "OK") {
                    toastMessage = "Timelogs Saved!";
                } else if (data.statusText === "AuditError") {
                    toastMessage = "No Saved!";
                } else if (data.statusText === "No") {
                    toastMessage = "No Saved!";
                }

                that.setState({
                    loading: false,
                    Headers: false,
                    TimelogList: { pennding: false, value: [] },
                    TimelogUpList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    selectAllDuplicates: false,
                    AddButton: "",
                    CompanyCode: "",
                    FileName: "Choose a file"
                });

                toastMessage && toast.success(toastMessage, {
                    className: {
                        opacity: 0.8
                    }
                });
            }).catch((error) => {

                that.setState({
                    loading: false,
                    Headers: false,
                    TimelogList: { pennding: false, value: [] },
                    TimelogUpList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    selectAllDuplicates: false,
                    AddButton: "",
                    CompanyCode: "",
                    FileName: "Choose a file"
                });
                if (error.response.status === 401) {
                    sessionStorage.setItem("user", '');
                    sessionStorage.setItem("token", '');
                    sessionStorage.setItem("rol", '');
                    sessionStorage.setItem("email", '');
                    sessionStorage.clear();
                    this.setState({ isAutenticated: false },
                        () => {
                            this.forceUpdate();
                        });
                } else if (error.response.data === "NoDB") {
                    toast.error("Company Code dosen't exist!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.data === "NotReseller") {
                    toast.error("This User does not have permission!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (error.response.data.Message === "400") {
                    toast.error("API Error for Reseller", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else {
                    toast.error("Error Data Base(Error: 500)", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }

    UpdateTimeLogHeaders = (value, name) => {
        this.setState(state => {
            let stateCopy = Object.assign({}, state);
            stateCopy.TimeLogHeaders[name] = value
            return stateCopy;
        })
    }

    UploadTimeLogList = (e) => {
        e.preventDefault();

        let actionType = this.state.selectedValue;

        let stateCopy = Object.assign({}, this.state);
        let dataList = stateCopy.TimelogUpList.value;
        if (dataList === "" || dataList === null || dataList === undefined || dataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
            return false
        }
        //this whole method can be refactored, no time for that
        let userIdPosition = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.UserId.value);
        let logTimePositionLogTime = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.LogTime.value);
        let deviceSerialNumberPosition = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.DeviceSerialNumber.value);
        let jobCodePosition = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.JobCode.value);
        let clockingTypePosition = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.ClockingType.value);
        let stringClockingTypePosition = stateCopy.HeadersList.indexOf(stateCopy.TimeLogHeaders.StringClockingType.value);

        let result = [];

        if (userIdPosition < 0) {
            toast.error("User Id field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (logTimePositionLogTime < 0) {
            toast.error("Log Time field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }


        //it should be a way to remove .length -1
        for (let i = 1; i < dataList.length - 1; i++) {
            let val = {
                USER_ID: dataList[i][userIdPosition],
                LOG_TIME: dataList[i][logTimePositionLogTime],
                DEVICE_SERIAL_NUMBER: dataList[i][deviceSerialNumberPosition],
                JOB_CODE: dataList[i][jobCodePosition],
                CLOCKING_TYPE0: dataList[i][clockingTypePosition],
                STRING_CLOCKING_TYPE0: dataList[i][stringClockingTypePosition],
            }
            result.push(val)
        }

        if (this.props.CompanyCode && dataList) {
            var duplicates = this.state.selectAllDuplicates ? "1" : "2";
            let listResult = TimelogServices.getTimelogsListResult(this.props.CompanyCode, result, actionType, duplicates);
            var that = this;
            listResult.then((data) => {
                if (data.statusText === 'OK') {
                    that.setState((state) => {
                        let stateCopy = Object.assign({}, state);
                        stateCopy.TimelogList = { pending: false, value: data.data };
                        stateCopy.checkboxOptions = [];

                        return stateCopy;
                    })
                }
            })
                .catch((error) => {
                    that.setState((state) => {
                        let stateCopy = Object.assign({}, state);
                        stateCopy.TimelogList = { pending: false, value: [] };
                        stateCopy.checkboxOptions = [];
                        return stateCopy;
                    });
                    let errorMesage = "";
                    if (error && error.response && error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        that.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            });
                        return;
                    }
                    if (error && error.response && error.response.data.Message) {
                        switch (error.response.data.Message) {
                            case '500': {
                                errorMesage = "Error Data Base(Error: 500)";
                                break;
                            }
                            case 'NoDB': {
                                errorMesage = "Company Code dosen't exist!";
                                break;
                            }
                            case 'NotReseller': {
                                errorMesage = "This User does not have permission!"
                                break;
                            }
                            case '400': {
                                errorMesage = "API Error for Reseller";
                                break;
                            }
                            default: {
                                errorMesage = "Unknown error";
                                break;
                            }
                        }
                    }
                    else {
                        error = "Code Error";
                    }
                    toast.error(errorMesage, {
                        className: {
                            opacity: 0.8
                        }
                    });
                })
        }





    }

    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item }
        });




        return (
            <div>

                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Timeclock CSV</span></h4>
                            </div>
                            {
                                this.props.CompanyCode
                                &&
                                <div className="upload-btn-wrapper" key={this.state.UploadInputKey}>
                                    <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.FileName}</button>
                                    <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.handleData(event) }} />
                                </div>
                            }
                            <div className="col-2 offset-3" style={{ 'paddingTop': '10px' }}>
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={TimelogFile} download="Example of Timelogs.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                        </div><br />
                        <div className="row ">
                            {/* <div className="col-2 offset-md-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Delete Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '1'}
                                            onChange={this.handleChange}
                                            value="1"
                                            name="radio-button-demo"
                                            aria-label="A"
                                            color="primary"
                                        />
                                    </div>
                                }

                            </div>
                            <div className="col-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Appends Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '2'}
                                            onChange={this.handleChange}
                                            value="2"
                                            name="radio-button-demo"
                                            aria-label="B"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>
                            <div className="col-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div style={{ 'paddingTop': '10px' }}>
                                        <label>Appends Duplicates</label>
                                        <Checkbox
                                            style={{ width: 25, height: 25 }}
                                            checked={this.state.selectAllDuplicates}
                                            onChange={this.SelectedAllDuplicates}
                                            //value={this.state.checkboxOptions}
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div> */}
                        </div>
                        <br /><br />
                        {
                            this.state.Headers &&
                            <div className="row">
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }}>User ID(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select

                                            value={this.state.TimeLogHeaders.UserId}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'UserId')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Log Time(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.TimeLogHeaders.LogTime}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'LogTime')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-3">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Device Serial Number:</label>
                                        <Select
                                            value={this.state.TimeLogHeaders.DeviceSerialNumber}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'DeviceSerialNumber')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Job Code:</label>
                                        <Select
                                            value={this.state.TimeLogHeaders.JobCode}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'JobCode')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Clocking Type</label>
                                        <Select
                                            value={this.state.TimeLogHeaders.ClockingType}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'ClockingType')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >String Clocking Type</label>
                                        <Select
                                            value={this.state.TimeLogHeaders.StringClockingType}
                                            onChange={value => {
                                                this.UpdateTimeLogHeaders(value, 'StringClockingType')
                                            }}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>

                                <div className="col-2 offset-8" style={{ paddingTop: '28px' }}>
                                    <div className="form-group">
                                        <button className="btn btn-info" onClick={(e) => { this.UploadTimeLogList(e) }} >Preview</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {

                    // (this.state.TimelogList.pennding
                    //     && <span className="loader"></span>)
                    // ||
                    (this.state.TimelogList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body">
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto' }}>
                                    <table className="table table-hover table-striped table-sm" >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                {/* <th scope="col">Company Code</th> */}
                                                <th scope="col">UserID</th>
                                                <th scope="col">Log Time</th>
                                                {/* <th scope="col">DeviceID</th> */}
                                                <th scope="col">Device Serial Number</th>
                                                <th scope="col">Job Code</th>
                                                {/* <th scope="col">Authorize Reason Code</th>
                                                <th scope="col">Locked</th> */}
                                                <th scope="col">Clocking Type</th>
                                                <th scope="col">String Clocking Type</th>
                                            </tr>
                                        </thead>
                                        <tbody style={scrollTable}>
                                            {
                                                (this.state.TimelogList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.TimelogList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.ID) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.ID)}
                                                                        value={item.ID}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                            }

                                                        </td>
                                                        {/* <td>{item.COMPANY_CODE}</td> */}
                                                        <td>{item.USER_ID}</td>
                                                        <td>{item.LOG_TIME.replace("T", " ")}</td>
                                                        {/* <td>{item.DEVICE_ID}</td> */}
                                                        <td>{item.DEVICE_SERIAL_NUMBER}</td>
                                                        <td>{item.JOB_CODE}</td>
                                                        {/* <td>{item.AUTHORIZE_REASON_CODE}</td> */}
                                                        <td>{item.CLOCKING_TYPE0}</td>
                                                        <td>{item.STRING_CLOCKING_TYPE0}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SaveTimelogList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}

export default TimelogImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/TimelogImportfile.jsx